import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'tokenize' })
export class TokenizePipe implements PipeTransform {
    public transform(val: string, params: string) {
        return  val.replace(new RegExp(params.toLocaleUpperCase(), 'g'), `<strong>${params.toLocaleUpperCase()}</strong>`);
    }
}
